import * as React from "react";
import { MetaTags } from "../../../head";

const About = () => [
  <MetaTags key={0} title="Về chúng tôi" />,
  <div key={1} className="tab-pane active">
    <h1>Về chúng tôi</h1>

    <p>
      Express Design là một dự án được lên ý tưởng từ tháng 2 năm 2017 và chính
      thức đi vào hoạt động từ tháng 6 năm 2017.
    </p>
    <p>
      Với sự hợp tác của 3 Founders đầu tiên gồm: Trần Trọng Hải, Mã Thị Hoàng
      Hà, Ngô Minh Quân, giờ đây Express Design là một đội ngũ vững mạnh với hơn
      10 thành viên cốt cán với đầy đủ kỹ năng, chuyên môn về lĩnh vực thiết kế
      và tư vấn thiết kế. Các thành viên đều là những người trẻ, tràn đầy nhiệt
      huyết và chung một mong muốn tạo ra một cuộc cách mạng đột phát về việc
      ứng dụng thương mại điện tử vào trong thiết kế.
    </p>
    <p>
      Nhìn nhận được những yếu điểm trong ngành thiết kế hiện nay, kết hợp cùng
      sự nghiên cứu thị trường, các nhà sáng lập Express Design đã kết hợp hài
      hòa giữa công nghệ, thiết kế, xen lẫn các trải nghiệm của người dùng.
    </p>
    <p>
      Tâm huyết, trí tuệ và sự nỗ lực không biết mệt mỏi của đội ngũ phát triển
      đã được chuyển hóa thành một mô hình sản phẩm / dịch vụ đầy tiềm năng và
      đang là ngọn cờ tiên phong trong lĩnh vực “Đặt hàng thiết kế trực tuyến”
    </p>

    <h3>Tầm nhìn</h3>
    <p>
      Express Design nỗ lực phát triển trở thành công ty hàng đầu trong việc đặt
      dịch vụ thiết kế trực tuyến tại Việt Nam. Thương mại điện tử hóa thành
      công ngành thiết kế.
    </p>
    <h3>Sứ mệnh</h3>
    <p>
      Express Design hướng tới xây dựng một mẫu số chung cho thị trường về Tốc
      độ - Giá cả và Chất lượng đối với tất cả các sản phẩm thiết kế đồ họa. Nơi
      mà mọi nhà thiết kế, khách hàng, đều có thể tham khảo được các vấn đề
      chung về dịch vụ thiết kế.
    </p>
    <h3>Giá trị cốt lõi</h3>
    <p>
      Express Design mang trong mình sự khác biệt về phương thức đạt hằng thiết
      kế. Với xu hướng thương mại điện tử ngày nay, Express Design đã và đang đi
      đúng hướng trong việc mang đến không chỉ sản phẩm chất lượng mà cả những
      trải nghiệm tuyệt vời nhất dành cho khách hàng.
    </p>
  </div>,
];

export default About;



// WEBPACK FOOTER //
// ./src/routes/StaticPages/components/About.tsx